// Toggles the floating add-to-cart bar based on whether the main product
// information block is in the viewport. Moved verbatim out of
// sections/product-information.liquid so it loads with `defer` instead of
// blocking the parser.
document.addEventListener('DOMContentLoaded', function () {
  const floatingAddToCart = document.getElementById('floating-add-to-cart');
  const productInformation = document.getElementById('gen-product-information');

  function checkVisibility() {
    const rect = productInformation.getBoundingClientRect();
    const inViewport = rect.top < window.innerHeight && rect.bottom > -100;

    if (!inViewport) {
      floatingAddToCart.classList.add('floating-add-to-cart-section-active');
    } else {
      floatingAddToCart.classList.remove('floating-add-to-cart-section-active');
    }
  }

  window.addEventListener('scroll', checkVisibility);
  window.addEventListener('resize', checkVisibility);
  checkVisibility();
});
